// @flow
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { VIEW_SIZE } from 'utils/device';
import { CATEGORY_ID } from 'utils/categories';
import ErrorBoundary from 'shared-components/ErrorBoundary/ErrorBoundary';
import withSelectedCategoryId from 'HOC/withSelectedCategoryId/withSelectedCategoryId';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import SelectSort from '../SelectSort/SelectSort';
import CategoryHeader from '../CategoryHeader/CategoryHeader';
import styles from './TertiaryHeader.module.css';

type InjectedProps = {|
  +selectedCategoryId: string | null,
|};

type StateProps = {|
  +searchQuery: string,
|};

type OwnProps = {|
  +viewSize: string,
|};

type Props = {| ...InjectedProps, ...OwnProps, ...StateProps |};

const TertiaryHeader = (props: Props) => {
  const { viewSize, selectedCategoryId, searchQuery } = props;
  const isFavoritesTab = selectedCategoryId === CATEGORY_ID.myfavorites;
  const displayBreadcrumbs =
    !searchQuery &&
    !isFavoritesTab &&
    (viewSize === VIEW_SIZE.large || viewSize === VIEW_SIZE.xLarge);
  const displaySort =
    !searchQuery &&
    selectedCategoryId !== CATEGORY_ID.mycart &&
    selectedCategoryId !== CATEGORY_ID.sponsored &&
    (viewSize === VIEW_SIZE.large || viewSize === VIEW_SIZE.xLarge);

  return (
    <section
      className={classNames(styles.tertiaryHeader, {
        [styles.results]: !!searchQuery,
        //TO DO: update categories to all use the same header and styles
        [styles.favoritesTab]: isFavoritesTab,
      })}
    >
      <div className={classNames(styles.container, 'page-row')}>
        {displayBreadcrumbs && (
          <ErrorBoundary>
            <Breadcrumbs />
          </ErrorBoundary>
        )}
        {isFavoritesTab && (
          <CategoryHeader
            title="My Favorites"
            subtitle="All favorited items available in this sale will be found here. This includes anything you have favorited in the past."
          />
        )}
        {displaySort && (
          <ErrorBoundary>
            <SelectSort />
          </ErrorBoundary>
        )}
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  searchQuery: state.searchState.searchQuery,
});

export default (compose(
  withSelectedCategoryId,
  connect(mapStateToProps)
)(TertiaryHeader): React.AbstractComponent<OwnProps>);
